import AnnouncementFormModal from './AnnouncementFormModal';

export default AnnouncementFormModal;
